export default {
	race_alt: 'yarış',
	gold_coin_alt: 'altın para',
	world_alt: 'Dünya',
	races_banner_alt: 'Yarışlar Bannerı',
	races_banner_mobile_alt: 'Yarışlar Mobil Bannerı',
	vipclub_icon_alt: 'VIP Kulüp İkonu',
	// UI elements
	chip_button_image_alt: 'çip buton görseli',
	error_alt: 'Hata',
	chest_alt: 'sandık',
	money_alt: 'para',
	usdt_alt: 'usdt',
	reward_alt: 'Ödül',
	handle_icon_alt: 'kontrol ikonu',
	input_icon_alt: 'giriş ikonu',
	illustration_alt: 'illüstrasyon',
	reward_icon_alt: 'ödül ikonu',
	arrow_left_alt: 'sol ok',
	arrow_right_alt: 'sağ ok',
	banner_background_alt: 'banner arka planı',
	promo_alt: 'promo',
	ellipse_alt: 'elips',
	orange_alt: 'turuncu',
	turnoff_alt: 'kapat',
	icon_alt: 'ikon',
	green_alt: 'yeşil',
	rollback_icon_alt: 'geri alma ikonu',
	shape_top_alt: 'Üst Şekil',
	shape_bottom_alt: 'Alt Şekil',
	edit_alias_alt: 'Takma Adı Düzenle',
	loading_alt: 'yükleniyor',
	learn_more_img_alt: 'daha fazla bilgi',
	loading_mobile_alt: 'mobil yükleniyor',
	show_password_alt: 'Şifreyi göster',
	logo_alt: 'logo',
	star_alt: 'yıldız',
	avatar_alt: 'avatar',
	section_illustration_alt: 'bölüm illüstrasyonu',
	diamond_alt: 'elmas',
	vip_icons_alt: 'VIP ikonları',
	cards_left_alt: 'sol kartlar',
	chests_alt: 'sandıklar',
	cards_right_alt: 'sağ kartlar',
	rakeboost_button_alt: 'Rakeboost Butonu',
	rakeboost_battery_alt: 'Rakeboost Bataryası',
	modal_header_alt: 'modal başlığı',
	site_logo_alt: 'Site Logosu',
	gold_coin_single_alt: 'Altın Para',
	gold_coins_alt: 'Altın Paralar',
	chest_and_gold_illustration_alt: 'sandık ve altın illüstrasyonu',
	percentage_alt: 'yüzde',
	// Crypto icons
	arb_alt: 'Arb',
	base_alt: 'Base',
	lightning_alt: 'Lightning',
	optimism_alt: 'Optimism',
	avax_alt: 'Avax',
	// Generic icons
	wallet_icon_alt: 'Cüzdan İkonu',
	x_icon_alt: 'X İkonu',
	dropdown_icon_alt: 'Açılır Menü İkonu',
	warning_new_icon_alt: 'Yeni Uyarı İkonu',
	originals_icon_alt: 'Originals İkonu',
	question_icon_alt: 'Soru İkonu',
	up_icon_alt: 'Yukarı İkonu',
	warning_icon_alt: 'Uyarı İkonu',
	search_icon_alt: 'Arama İkonu',
	reddit_icon_alt: 'Reddit İkonu',
	free_spins_icon_alt: 'Free Spins İkonu',
	popular_icon_alt: 'Popüler İkonu',
	events_tickets_icon_alt: 'Etkinlik Biletleri İkonu',
	vip_header_icon_alt: 'VIP Başlık İkonu',
	trash_icon_alt: 'Çöp İkonu',
	testimonials_icon_alt: 'Yorumlar İkonu',
	lock_icon_alt: 'Kilit İkonu',
	sports_icon_alt: 'Spor İkonu',
	recently_tab_icon_alt: 'Son Eklenenler Sekme İkonu',
	arrow_icon_alt: 'Ok İkonu',
	support_icon_alt: 'Destek İkonu',
	wallet_game_icon_alt: 'Oyun Cüzdanı İkonu',
	info_icon_alt: 'bilgi ikonu',
	// Payment methods
	chips_alt: 'Çipler',
	visa_alt: 'Visa',
	gpay_alt: 'GPay',
	mastercard_alt: 'MasterCard',
	apple_pay_alt: 'Apple Pay',
	// VIP section
	become_vip_alt: 'VIP Ol',
	left_control_alt: 'Sol kontrol ikonu',
	right_control_alt: 'Sağ kontrol ikonu',
	provider_logo_alt: 'Sağlayıcı logosu',
	// Banners & illustrations
	crypto_banner_alt: 'Kripto bannerı',
	spinner_alt: 'Yükleniyor',
	reward_icon_image_alt: 'Ödül İkonu',
	join_now_alt: 'Ok ikonu',
	banner_alt: 'Banner',
	// Referral & rewards
	referral_project_alt: 'Referans projesi',
	coin_alt: 'Para',
	coin_bg_alt: 'Para arka planı',
	moneybox_alt: 'Para kutusu',
	box_alt: 'Kutu',
	hat_illustration_alt: 'Şapka illüstrasyonu',
	how_it_works_illustration_alt: "Referans bonusunu tanıtan uzay giysili astronotlar",
	invite_friends_banner_alt: 'Arkadaş Davet Bannerı',
	top_arc_alt: 'Üst Yay',
	bottom_arc_alt: 'Alt Yay',
	unlock_alt: 'Kilidi Aç',
	card_background_alt: 'Kart arka planı',
	// Calendar & dates
	calendar_icon_alt: 'Takvim ikonu',
	// Level & progression
	level_up_alt: 'Seviye atla',
	tier_card_img_alt: 'Seviye kartı',
	person_alt: 'Kişi',
	// Chat & media
	selected_gif_alt: 'Seçili GIF',
	close_icon_alt: 'Kapat ikonu',
	message_icon_alt: 'Mesaj ikonu',
	option_user_icon_alt: 'Kullanıcı seçenek ikonu',
	selected_option_icon_alt: 'Seçili seçenek ikonu',
	// Misc
	hero_banner_alt: 'Ana Banner',
	meme_icon_alt: 'Meme ikonu',
	first_page_alt: 'İlk sayfa',
	last_page_alt: 'Son sayfa',
	no_transactions_illustration_alt: 'İşlem yok illüstrasyonu',
	coming_soon_banner_alt: 'Yakında bannerı',
	maintenance_alt: 'Bakım',
	geoblock_alert_alt: 'Bölgesel Engelleme Uyarısı',
	welcome_modal_illustration_alt: 'Hoş Geldiniz Modal İllüstrasyonu',
	deposit_bonus_alt: 'Bonus',
	section_icon_alt: 'Bölüm ikonu',
	step_image_alt: 'Adım görseli'
};
